/**
 * The `state` to send when opening /login from a page header, so that after signing in the user
 * comes back to the page they were on. Login (`pages/auth/login.js`) and `PublicLoginRoute` already
 * honor `state.from`; the header used to set it only on event pages, so a visitor who signed in
 * from a professional's booking link (`/beauty/:salonRef/:profesionalSlug`) landed on /event and
 * lost the preselected professional, which lives in that URL.
 *
 * Returns undefined for the home page, auth pages and the organizer panel: there is nothing to
 * come back to there, and login already refuses to return to those.
 */
export function loginStateFrom(location) {
  const pathname = location?.pathname || "";
  if (!pathname || pathname === "/" || /^\/(login|register|organizer)(\/|$)/.test(pathname)) return undefined;
  return { from: pathname + (location?.search || "") };
}
